import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
  const location = useLocation();
  const isAuthPage = ['/login', '/register'].includes(location.pathname);
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          paddingTop: isAuthPage ? 8 : 3,
          paddingX: { xs: 2, sm: 3, md: 4 },
          paddingBottom: 3
        }}
      >
        {children}
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;